import { usePointOfSaleHoursCalendar } from '../../../data_fetching/PointOfSaleHours/PointOfSaleHoursCalendar';
import { UserInterface } from '../../../interfaces/User';
import { FasceOrarie } from '../utility_objects/FasceOrarieUtils';

/** Fasce del punto vendita per giorno ('YYYY-MM-DD'); null = negozio chiuso. */
export type OrariNegozio = Record<string, FasceOrarie | null>;

const NESSUN_UTENTE: UserInterface[] = [];

/** Ricaricati ogni 5 minuti, come il calendario e le altre query della fascia. */
const RICARICA_MS = 300000;

/**
 * Orari del punto vendita nei giorni del calendario, per «Orario negozio» nelle
 * chip di Presenze totali. Riusa la query degli orari che il calendario ha già
 * (usePointOfSaleHoursCalendar) con gli stessi parametri, quindi la stessa chiave:
 * nessuna chiamata in più, e i dati restano finché il calendario la osserva (la
 * query ha cacheTime 0). staleTime Infinity vale solo per questo osservatore:
 * accendere Presenze totali con gli orari già letti non li richiede di nuovo.
 * Con un solo operatore selezionato il calendario legge gli orari di quell'operatore
 * e non del negozio: qui allora si chiedono quelli del negozio, con una chiamata a
 * parte. Con `attiva` false nessuna chiamata.
 *
 * Ricarica ogni 5 minuti, come le presenze in servizio. Con la chiave condivisa
 * calendario e fascia ricaricano insieme, senza chiamate in più: react-query a ogni
 * ricarica riallinea i timer di tutti gli osservatori della query. Con un solo
 * operatore la chiamata a parte si ricarica da sola, e così si riprova anche una
 * chiamata fallita.
 *
 * undefined = orari non ancora arrivati; una chiamata fallita restituisce una mappa
 * vuota (la query non va mai in errore): in entrambi i casi le chip mostrano
 * l'orario.
 */
export const useOrariNegozio = ({
  pointOfSaleId,
  selectedDate,
  view,
  selectedUsers,
  attiva,
}: {
  pointOfSaleId: string;
  /** Data selezionata così com'è nello store della pagina (fa parte della chiave). */
  selectedDate: Date;
  view: string;
  selectedUsers: UserInterface[];
  attiva: boolean;
}): OrariNegozio | undefined => {
  const { data } = usePointOfSaleHoursCalendar({
    pointOfSaleId,
    selectedDate,
    view,
    selectedUsers: selectedUsers.length === 1 ? NESSUN_UTENTE : selectedUsers,
    options: {
      enabled: attiva,
      staleTime: Infinity,
      refetchInterval: RICARICA_MS,
      useErrorBoundary: false,
    },
  });
  return data as OrariNegozio | undefined;
};
